import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { bulkSMSService } from '../../lib/services.patientinfo';
import toast from 'react-hot-toast';

const SMSOthersNumber: React.FC = () => {
  const [phoneNumbers, setPhoneNumbers] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  const handleSendSMS = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!phoneNumbers.trim()) {
      toast.error('Please enter phone numbers');
      return;
    }
    
    if (!message.trim()) {
      toast.error('Please enter a message');
      return;
    }

    setSending(true);
    try {
      const numbers = phoneNumbers
        .split('\n')
        .map(n => n.trim())
        .filter(n => n.length > 0);

      if (numbers.length === 0) {
        toast.error('No valid phone numbers found');
        return;
      }

      await bulkSMSService.sendToCustomNumbers(numbers, message, 'System');
      
      toast.success(`SMS sent to ${numbers.length} numbers successfully`);
      setPhoneNumbers('');
      setMessage('');
    } catch (error: any) {
      toast.error(error.message || 'Failed to send SMS');
    } finally {
      setSending(false);
    }
  };

  const phoneCount = phoneNumbers.split('\n').filter(n => n.trim().length > 0).length;

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-sm p-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Bulk SMS Others Number</h1>
          <p className="text-gray-600">Send SMS to custom phone numbers not in the patient database.</p>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm p-6">
        <form onSubmit={handleSendSMS} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Recipients Numbers *
            </label>
            <textarea
              value={phoneNumbers}
              onChange={(e) => setPhoneNumbers(e.target.value)}
              rows={8}
              placeholder="Number input example below:
01982607043
01302870518
01601680909"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 font-mono text-sm"
            />
            <p className="mt-2 text-sm text-red-600">Enter separated Number</p>
            {phoneCount > 0 && (
              <p className="mt-1 text-sm text-gray-600">{phoneCount} numbers entered</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Message *
            </label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={6}
              placeholder="Type your message here..."
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
            />
          </div>

          <button
            type="submit"
            disabled={sending || !phoneNumbers.trim() || !message.trim()}
            className="flex items-center space-x-2 bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Send className="w-4 h-4" />
            <span>{sending ? 'Sending...' : 'Send SMS'}</span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default SMSOthersNumber;
